function SectionCandidateSkills() {
    return (
        <>
            <h4 className="twm-s-title">Skills</h4>
            <div className="tw-sidebar-tags-wrap">
                <div className="tagcloud">
                    <a href="/can-list?skill=Finance">Finance</a>
                    <a href="/can-list?skill=Sales">Sales</a>
                    <a href="/can-list?skill=Part-time">Part-time</a>
                    <a href="/can-list?skill=Administration">Administration</a>
                    <a href="/can-list?skill=Retail">Retail</a>
                    <a href="/can-list?skill=Engineering">Engineering</a>
                    <a href="/can-list?skill=Developer">Developer</a>
                    <a href="/can-list?skill=Work%20from%20home">Work from home</a>
                    <a href="/can-list?skill=IT%20Consulting">IT Consulting</a>
                    <a href="/can-list?skill=Manufacturing">Manufacturing</a>
                </div>
            </div>
        </>
    )
}

export default SectionCandidateSkills;
